import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  formData: {
    iibCount: null,
  },
};

//bi fetched
const fetchIIbCount = (state, action) => {
  // console.log("IIB--->",state)
  // console.log("IIB--->",action)
  return updateObject(state, {
    iibCount: action.formData,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // lead
    case actionTypes.IIBCOUNT:
      return fetchIIbCount(state, action);

    default:
      return state;
  }
};

export default reducer;
